import React from 'react';
import "../styles/background.css"


function Background() {
  return (
   
    <div id="retrobg">
              <div id="retrobg-sky">
              <div id="retrobg-stars">
            <div className="retrobg-star" style={{left:  "5%", top: "55%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left:  "7%", top: " 5%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "10%", top: "45%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "12%", top: "35%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "15%", top: "39%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "20%", top: "10%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "35%", top: "50%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "40%", top: "16%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "43%", top: "28%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "45%", top: "30%", transform: 'scale( 3 )'}}></div>
            <div className="retrobg-star" style={{left: "55%", top: "18%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "60%", top: "23%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "62%", top: "44%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "67%", top: "27%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "75%", top: "10%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "80%", top: "25%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "83%", top: "57%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "90%", top: "29%", transform: 'scale( 2 )'}}></div>
            <div className="retrobg-star" style={{left: "95%", top: " 5%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "96%", top: "72%", transform: 'scale( 1 )'}}></div>
            <div className="retrobg-star" style={{left: "98%", top: "70%", transform: 'scale( 3 )'}}></div>
          </div>
          <div id="retrobg-sunWrap">
            <div id="retrobg-sun"></div>
          </div>
          <div id="retrobg-mountains">
            <div id="retrobg-mountains-left" class="retrobg-mountain"></div>
            <div id="retrobg-mountains-right" class="retrobg-mountain"></div>
          </div>
          <div id="retrobg-cityWrap">
            <div id="retrobg-city">
              <div style={{left: " 4.0%", height: "20%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: " 6.0%", height: "50%", width: "1.5%"}} className="retrobg-building"></div>
              <div style={{left: " 8.0%", height: "25%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "12.0%", height: "30%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "13.0%", height: "55%", width: "3.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "17.0%", height: "20%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "18.5%", height: "70%", width: "1.5%"}} className="retrobg-building"></div>
              <div style={{left: "20.0%", height: "30%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "21.5%", height: "80%", width: "2.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "25.0%", height: "60%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "28.0%", height: "40%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "30.0%", height: "70%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "35.0%", height: "65%", width: "4.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "38.0%", height: "40%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "42.0%", height: "60%", width: "2.0%"}} className="retrobg-building"></div>
              <div style={{left: "43.0%", height: "85%", width: "4.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "45.0%", height: "40%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "48.0%", height: "25%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "50.0%", height: "80%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "52.0%", height: "32%", width: "5.0%"}} className="retrobg-building"></div>
              <div style={{left: "55.0%", height: "55%", width: "3.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "58.0%", height: "45%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "61.0%", height: "90%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "66.0%", height: "99%", width: "4.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "69.0%", height: "30%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "73.5%", height: "90%", width: "2.0%"}} className="retrobg-building"></div>
              <div style={{left: "72.0%", height: "70%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "75.0%", height: "60%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "80.0%", height: "40%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "83.0%", height: "70%", width: "4.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "87.0%", height: "60%", width: "3.0%"}} className="retrobg-building retrobg-antenna"></div>
              <div style={{left: "93.0%", height: "50%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "91.0%", height: "30%", width: "4.0%"}} className="retrobg-building"></div>
              <div style={{left: "94.0%", height: "20%", width: "3.0%"}} className="retrobg-building"></div>
              <div style={{left: "98.0%", height: "35%", width: "2.0%"}} className="retrobg-building"></div>
            </div>
          </div>
        </div>
        <div id="retrobg-ground">
          <div id="retrobg-linesWrap">
            <div id="retrobg-lines">
              <div id="retrobg-vlines">
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
                <div className="retrobg-vline"></div>
              </div>
              <div id="retrobg-hlines">
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
                <div className="retrobg-hline"></div>
              </div>
            </div>
          </div>
          <div id="retrobg-groundShadow"></div>
        </div>
          </div> 
    
  )
}

export default Background;
